export const getExtension = (name: string) => {
    const split = name.split('.');

    return split[split.length - 1]?.toLowerCase();
};

export const getFileExtensions = (file: File) => getExtension(file.name);

export const isValidExtension = (name: string, extensions: string[]) => {
    const extension = getExtension(name || '');

    return !!extensions.find((allowedExt) => allowedExt === `.${extension}`);
};
